import {
  ReporteLiderComercialMockUp,
  ResumenLiderComercialMockUp
} from "./ReporteLiderComercial.types";

export const mockResumen: ResumenLiderComercialMockUp = {
  operaciones: 2417,
  descuentos: -16,
  alcance: 72.5,
  meta: 3450,
  asesores: 250
};

export const mockData: ReporteLiderComercialMockUp[] = [
  {
    numEmpleado: "SWPED",
    empleado: "San Pedro",
    ventas: 50,
    reactivaciones: 40,
    integrantes: 28,
    extras: 14,
    rescuentos: -16
  }
];
